import PageHeader from 'common/components/PageHeader/PageHeader';
import AlertsContext from 'common/contexts/alerts';
import useAuth from 'common/contexts/auth';
import useRouter from 'common/hooks/use-router';
import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import useItem from '../../../common/hooks/useItem';
import TodoForm from './TodoForm';

const Todo = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const { isAdmin, isManager } = useAuth();
  const { setAlert } = useContext(AlertsContext);
  const { id: todoId } = router.match.params;
  const {
    saveItem, updateItem, item, error,
  } = useItem('todos', todoId);

  const back = useCallback(() => {
    if (!error) {
      setAlert(t('common.saved'), 'success');
      if (isAdmin || isManager) {
        router.push('/todos');
      } else {
        router.push('/my-tasks');
      }
    } else {
      setAlert(error, 'danger');
    }
  }, [setAlert, router, error, t, isAdmin, isManager]);

  const onSubmit = useCallback(async (data) => {
    let todo = { ...data };
    const missingCheck = data.subitems.filter(val => val.state).length < data.subitems.length;

    if (data.subitems.length) {
      todo = { ...data, state: !missingCheck };
    }

    if (todo.id) {
      await updateItem(todo.id, todo);
      back();
    } else {
      await saveItem(todo);
      back();
    }
  }, [updateItem, back, saveItem]);

  return (
    <>
      <PageHeader
        title={t(`common.${item && item.id ? 'edit' : 'add'}`)}
        subLink={{
          url: '/todos',
          icon: 'arrow-left',
          goBack: true,
          label: t('common.back'),
        }}
      />
      <section className="section form-page has-cards">
        <TodoForm onSubmit={onSubmit} todo={item} />
      </section>
    </>
  );
};

export default Todo;
